import styled from 'styled-components';

import { theme } from '../../global-styles/colors';

export const AssistanceNotificationStyle = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  background-color: ${theme.status.alert.light};
  margin-bottom: 16px;
  cursor: pointer;

  &.assistance-arrived {
    background-color: ${theme.status.success.light};
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
    transform: scale(1);
    animation: pulse 2s infinite;
    .assistance-icon {
      background-color: rgb(189, 219, 185);
    }
  }

  &.media {
    background-color: #9ad9ea;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
    transform: scale(1);
    animation: pulse 2s infinite;
    .assistance-icon {
      padding: 0;
    }
  }

  .assistance-arrow {
    visibility: hidden;
  }

  .show-arrow {
    visibility: visible;
  }

  .assistance {
    &-icon {
      width: 32px;
      height: 32px;
      background-color: ${theme.status.alert.medium};
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px;
      margin-right: 16px;
      border-radius: 8px;
    }

    &-arrow {
      width: 16px;
    }

    &-text {
      margin-right: auto;
      letter-spacing: 0em;
      text-align: left;

      &--bold {
        font-weight: bold;
      }
    }
  }

  &.no-pointer-events {
    pointer-events: none;
  }
  &.disabled {
    pointer-events: none;
    animation: none;
  }
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgb(7, 69, 38, 0.6);
    }

    60% {
      box-shadow: 0 0 0 8px rgb(7, 69, 38, 0);
    }

    100% {
      box-shadow: 0 0 0 0 rgb(7, 69, 38, 0);
    }
  }
`;
